import { Box, Container, Grid, Typography } from "@mui/material"
import { useApiGet } from "auth/useApi2"
import { GlobalLoaderContext } from "components/GlobalLoadingProvider"
import { TabPanel } from "components/navigation/TabPanel"
import PaperBox from "components/PaperBox"
import { SkeletonCard } from "components/skeleton/SkeletonCard"
import SubTabs from "components/SubTabs"
import { apiEndpoints } from "generated/apiEndpoints"
import { useContext, useEffect, useState } from "react"
import CustomRoleList from "shared/customer/CustomRoles/CustomRoleList"
import RoleTemplatesList from "shared/customer/RoleTemplates/RoleTemplatesList"
import { EditCustomerForm } from "../../components/EditCustomerForm"
import { useTranslation } from "react-i18next"

const EditCustomer = () => {
  const [customerResult, getCustomer] = useApiGet()
  const [logoResult, getLogoData] = useApiGet()
  const [tabValue, setTabValue] = useState(0)
  const loadingContext = useContext(GlobalLoaderContext)
  const { t } = useTranslation()

  const tabData = [
    {
      index: 0,
      label: t("settings.customer.customer_data", "Customer data"),
      queryParam: "customerSettings"
    },
    { index: 1, label: t("settings.customer.roles", "Roles"), queryParam: "roles" },
    { index: 2, label: t("settings.customer.role_templates", "Role templates"), queryParam: "roletemplates" }
  ]

  useEffect(() => {
    getCustomer(apiEndpoints.customeradmin.getcustomer)
  }, [getCustomer])
  useEffect(() => {
    if (customerResult.data && customerResult.data.logoName) {
      getLogoData(
        apiEndpoints.customeradmin.getcustomerlogobyname.concat("?name=" + customerResult.data.logoName)
      )
    }
  }, [customerResult, getLogoData])

  useEffect(() => {
    loadingContext.setLoading(() => customerResult.status === 1)
  })
  useEffect(() => {
    loadingContext.setLoading(() => logoResult.status === 1)
  })

  return (
    <>
      {customerResult.status === 2 ? (
        <Container>
          <Grid item xs={12} mb={5}>
            <Typography variant="h1">{t("settings.customer.customer_data", "Customer data")}</Typography>
          </Grid>
          <SubTabs tabs={tabData} value={tabValue} setValue={setTabValue} marginLeft={1} />
          <TabPanel value={tabValue} index={0}>
            <PaperBox mt={0}>
              <EditCustomerForm t={t} initialValues={customerResult.data} logoResult={logoResult} />
            </PaperBox>
          </TabPanel>
          <TabPanel value={tabValue} index={1}>
            <Grid container>
              <Grid item xs={12} lg={8}>
                <PaperBox sx={{ p: 0 }} mt={0}>
                  <CustomRoleList t={t} />
                </PaperBox>
              </Grid>
            </Grid>
          </TabPanel>
          <TabPanel value={tabValue} index={2} mt={0}>
            <PaperBox sx={{ p: 0 }} mt={0}>
              <RoleTemplatesList t={t} isSystemAdmin={false} customerId={customerResult.data.id} />
          </PaperBox>
          </TabPanel>
        </Container>
      ) : (
        <Container>
          <SkeletonCard />
        </Container>
      )}
    </>
  )
}
export default EditCustomer
